import React, { useCallback, useEffect, useState } from 'react'
import AddEvent from './AddEvent'
import Api from "../../utils/Api";
import { useNavigate, useParams } from 'react-router-dom';
import { message, Spin } from 'antd';
import { useEvent } from '../../contexts/EventContext';

export default function EditEvent({ role }) {
    const { id } = useParams();
    const { events } = useEvent();
    const navigate = useNavigate();

    const [eventData, setEventData] = useState({})
    const [loading, setLoading] = useState(false);

    const fetchEvent = useCallback(async () => {
        try {
            setLoading(true);
            const event = await events.find(ev => ev.id == id);
            if (!event) {
                const response = await Api.get(`/event/${id}`);
                setEventData(response.data.data);
            } else {
                setEventData(event);
            }
        } catch (error) {
            console.error(error);
            message.error('Failed to fetch event data.');
            navigate(-1);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchEvent();
    }, [])

    if (loading)
        return <Spin fullscreen spinning={loading} tip="Fetching data..." />

    return (
        <AddEvent role={role} edit={true} eventData={eventData} />
    )
}